import { useMutation, useQuery } from '@tanstack/react-query';
import { MEMBERSHIP_ROLE_LABELS } from '@raro/domain';
import { Button, Field, Input, MachineRaroBrand, Notice, Serif } from '@raro/ui';
import { useState, type FormEvent } from 'react';
import { Navigate, useParams } from 'react-router';
import ocean from '../assets/ocean.jpg';
import { api, setToken } from '../lib/api';
import type { InvitationPeek } from '../lib/types';

export function ConvitePage() {
  const { token = '' } = useParams();
  const peek = useQuery({ queryKey: ['invite', token], queryFn: () => api.get<InvitationPeek>(`/invitations/peek/${token}`), retry: false });
  const [f, setF] = useState({ name: '', password: '', title: '', company: '', specialty: '' });
  const accept = useMutation({
    mutationFn: () => api.post<{ accessToken: string }>('/invitations/accept', { token, ...f, title: f.title || undefined, company: f.company || undefined, specialty: f.specialty || undefined }),
    onSuccess: (d) => { setToken(d.accessToken); window.location.assign('/'); },
  });
  if (accept.isSuccess) return <Navigate to="/" replace />;
  const p = peek.data;
  const submit = (e: FormEvent) => { e.preventDefault(); accept.mutate(); };
  return (
    <div className="rr-auth">
      <section className="rr-auth__hero"><img className="rr-auth__hero-img" src={ocean} alt="" aria-hidden="true" /><MachineRaroBrand size="xl" /><p className="rr-heading">tornar visível<br />o que é visível.</p></section>
      <section className="rr-auth__panel">
        <form className="rr-auth__form rr-form" onSubmit={submit}>
          {peek.isError && <Notice tone="error">{(peek.error as Error).message}</Notice>}
          {p && (
            <>
              <div className="rr-stack rr-stack--2">
                <span className="rr-label">convite · {MEMBERSHIP_ROLE_LABELS[p.role]}</span>
                <h1 className="rr-title">{p.isHome ? <>Bem-vindo à <Serif italic>Raro</Serif>.</> : <>Bem-vindo à sala <Serif italic>RARO × {p.organization}</Serif>.</>}</h1>
                {p.message && <p className="rr-muted">“{p.message}”</p>}
                <p className="rr-faint" style={{ fontSize: 'var(--rr-text-sm)' }}>{p.email}</p>
              </div>
              {p.existingAccount ? (
                <Notice>você já tem conta com este e-mail. entre e o convite será aplicado.</Notice>
              ) : (
                <>
                  <Field label="Seu nome" htmlFor="c-name"><Input id="c-name" value={f.name || p.name || ''} onChange={(e) => setF({ ...f, name: e.target.value })} required minLength={2} autoFocus /></Field>
                  <Field label="Senha" htmlFor="c-pass" hint="mínimo de 8 caracteres"><Input id="c-pass" type="password" value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} required minLength={8} /></Field>
                  {p.role === 'network' ? (
                    <>
                      <Field label="Empresa / ateliê" htmlFor="c-co"><Input id="c-co" value={f.company} onChange={(e) => setF({ ...f, company: e.target.value })} /></Field>
                      <Field label="Especialidade" htmlFor="c-sp"><Input id="c-sp" value={f.specialty} onChange={(e) => setF({ ...f, specialty: e.target.value })} placeholder="fotografia, motion, copy…" /></Field>
                    </>
                  ) : (
                    <Field label="Cargo" htmlFor="c-title"><Input id="c-title" value={f.title} onChange={(e) => setF({ ...f, title: e.target.value })} /></Field>
                  )}
                </>
              )}
              {accept.isError && <Notice tone="error">{(accept.error as Error).message}</Notice>}
              <div className="rr-form__actions">
                {p.existingAccount ? <Button variant="primary" onClick={() => accept.mutate()} disabled={accept.isPending}>aceitar e entrar</Button> : <Button variant="primary" type="submit" disabled={accept.isPending || (f.name || p.name || '').length < 2 || f.password.length < 8}>criar minha conta</Button>}
              </div>
            </>
          )}
        </form>
      </section>
    </div>
  );
}
